export const TYPE = "server"
